<div class="chart-container">
  @if (isLoading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  <canvas baseChart
    [data]="barChartData"
    [options]="barChartOptions"
    [type]="'bar'">
  </canvas>
</div>
